import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Traveller's word" />
      <h1 className="headtext__cormorant">What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">Our happiest moments as tourists always seem to come when we stumble upon one thing while in pursuit of something else.</p>
        </div>
        <p className="p__opensans">  </p>
      </div>

      <div className="app__chef-sign">
        <p>Lawrence Block</p>
        <p className="p__opensans">traveller</p>
        <img src={images.sign} alt="" />
      </div>
    </div>
  </div>
);

export default Chef;
